import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function AbortController_0() {
  return new AbortController();
}
function *readChunk(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.z10();
    var continuation = cancellable;
    var tmp = _this__u8e3s4.read();
    var tmp_0 = tmp.then((it) => {
      var chunk = it.value;
      var result = it.done ? null : chunk;
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(result);
      this_0.rc(tmp$ret$5);
      return Unit_instance;
    });
    tmp_0.catch((cause) => {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(cause));
      this_0.rc(tmp$ret$7);
      return Unit_instance;
    });
    return cancellable.jy();
  };
}
function asByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return new Int8Array(_this__u8e3s4.buffer, _this__u8e3s4.byteOffset, _this__u8e3s4.length);
}
//region block: exports
export {
  AbortController_0 as AbortController21osa5gzjz756,
  asByteArray as asByteArray2l3hscb95qi13,
  readChunk as readChunk2eb2y4rrcqgn5,
};
//endregion

//# sourceMappingURL=Js.mjs.map
